import api from '../axiosConfig';

const API_URL = '/api/stock-return';

export const fetchStockReturns = () => api.get(API_URL);
export const fetchStockReturnById = (id) => api.get(`${API_URL}/${id}`);
export const createStockReturn = (data) => api.post(API_URL, data);
export const updateStockReturn = (id, data) => api.put(`${API_URL}/${id}`, data);
export const processStockReturn = (id, processed_by) => api.put(`${API_URL}/${id}/process`, { processed_by });
export const deleteStockReturn = (id) => api.delete(`${API_URL}/${id}`); 